import React, { forwardRef } from 'react';
import { FileUpload } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

const FileUploadWrapper = forwardRef<HTMLInputElement, FieldRenderProps<any>>((props, ref) => {
  const { render, children, input, maxFiles, error, ...otherProps } = props;
  return <FileUpload {...input} {...otherProps} error={error} maxFiles={maxFiles} ref={ref} />;
});

FileUploadWrapper.displayName = 'FileUploadWrapper';

export default FileUploadWrapper;
